import { LuMoon, LuSun } from 'react-icons/lu';
import { IconButton } from '@/components/ui/lib/icon-button';
import { Tooltip } from '@/components/ui/lib/tooltip';
import { DICTIONARY } from '@/config/dictionary';
import { useAppStore } from '@/stores/app-store';

const ColorModeToggleButton = () => {
  const { colorMode, toggleColorMode } = useAppStore();

  return (
    <Tooltip
      content={
        colorMode === 'dark' ? DICTIONARY.nav.darkModeTooltip : DICTIONARY.nav.lightModeTooltip
      }
      positioning={{ placement: 'right' }}
      openDelay={300}
    >
      <IconButton
        aria-label={DICTIONARY.nav.themeToggleAriaLabel}
        variant="ghost"
        size="sm"
        onClick={toggleColorMode}
        className="text-muted hover:bg-subtle hover:text-base"
      >
        {colorMode === 'dark' ? <LuSun className="h-5 w-5" /> : <LuMoon className="h-5 w-5" />}
      </IconButton>
    </Tooltip>
  );
};

export default ColorModeToggleButton;
